export default __webpack_public_path__ + "static/media/DarkBackground.64588d36.png";